import { IIconProps } from '../../types/IconProps.interface'

export const IconCross = ({ color = 'white' }: IIconProps) => {
  return (
    <svg className='w-full' fill='none' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15 5L5 15M5 5L15 15'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
      />
    </svg>
  )
}
